<template>
  <div class="relative pb-16 md:pb-24 overflow-x-hidden">
    <img src="~/assets/img/shapes/circle-drk-red-2.svg" class="circles--right">
    <img src="~/assets/img/shapes/circle-light-red.svg" class="circles--left">

    <header class="flex flex-col pt-24 pb-10 text-center items-center w-3/4 lg:w-2/3 mx-auto">
      <div v-if="headerText" class="content prose" v-html="headerText"/>
      <div v-else>
        <div class="h2 text-secondary-dark mb-2">
          Verschillende pakketten voor ouders
        </div>
        <p>
          Een begeleidingtraject begint met een vrijblijvend kennismakingsgesprek.<br>
          Bekijk het pakket dat je wil en vraag hem hieronder aan.
        </p>
      </div>
    </header>

    <section class="wave-shape pt-32 pt-24">
      <div class="flex flex-wrap justify-center container relative z-10 -mt-32 mb-6">
        <quicklinks-block
          v-for="pakket in pakketten"
          :key="pakket.title"
          :clickable-links="false"
          :pakket="pakket"
          class="z-20 mb-8 md:mb-0"
        />

        <footer class="w-full text-center mt-12">
          <nuxt-link to="/contact" class="btn btn-secondary">
            Vraag Kennismakingsgesprek aan
          </nuxt-link>
        </footer>
      </div>
    </section>
  </div>
</template>

<script>
import QuicklinksBlock from '../QuicklinksBlock';

export default {
  components: {QuicklinksBlock},
  props: {
    pakketten: {
      type: Array,
      default: () => ([]),
    },
    headerText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.wave-shape {
  @apply w-full;
  background-image: url("~assets/img/shapes/lightwave.svg");
  background-repeat: no-repeat;
  min-height: 600px;
}

.circles {
  &--right {
    @apply absolute opacity-25;
    top: -22%;
    right: 0;
  }
  &--left {
    @apply absolute;
    top: 35%;
    left: -10%;
  }
}
</style>
